import api from "../axiosConfig/axios";
import endpoints from "../endpoints/endpoints";

//get boxes based on categories
export const boxCategory = async (category, payload = {}) => {
  try {
    const {
      page = 1,
      per_page = 10,
      search = "",
      subCategories = [],
      filter_by = "",
      order_by = "",
    } = payload;

    return await api.get(`${endpoints.boxCategory}/${category}`, {
      params: {
        page,
        per_page,
        search,
        ...(subCategories.length && { sub_categories: subCategories }),
        ...(filter_by && { filter_by }),
        ...(order_by && { order_by }),
      },
    });
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get popular boxes
export const popularBoxes = async () => {
  try {
    return await api.get(`${endpoints.popularBoxes}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get box sub categories
export const boxesSubCategories = async () => {
  try {
    return await api.get(`${endpoints.boxSubCategories}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get all boxes
export const allBoxes = async () => {
  try {
    return await api.get(`${endpoints.allBoxes}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get all boxes
export const getFreeBoxes = async () => {
  try {
    return await api.get(`${endpoints.freeBoxes}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get products inside a box
export const boxProducts = async (boxName) => {
  try {
    return await api.get(`${endpoints.boxProducts}/${boxName}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get box categories
export const getBoxCategories = async () => {
  try {
    return await api.get(`${endpoints.boxCategories}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//post user detail
export const postUserDetils = async (payload) => {
  try {
    return await api.post(`${endpoints.postUserDetils}`, payload);
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      return { data: { success: false, message: error.message } };
    }
  }
};

//update user password
export const updatePassword = async (payload) => {
  try {
    return await api.post(`${endpoints.updatePassword}`, payload);
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      return { data: { success: false, message: error.message } };
    }
  }
};

//post user shipping detail
export const postUserShippingDetails = async (payload) => {
  try {
    return await api.post(`${endpoints.postUserShippingDetails}`, payload);
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      return { data: { success: false, message: error.message } };
    }
  }
};

//get user detail
export const mine = async () => {
  try {
    return await api.get(`${endpoints.mine}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get user detail
export const userSocialToken = async (payload) => {
  try {
    return await api.post(endpoints.exchangeCode, payload);
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      return { data: { success: false, message: error.message } };
    }
  }
};

export const spinWheel = async (id, version, redemptionId) => {
  try {
    return await api.get(
      `${endpoints.spinWheel}/${id}/${version}/${1}${
        redemptionId ? `?redemption_id=${redemptionId}` : ""
      }`,
    );
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      return { data: { success: false, message: error.message } };
    }
  }
};

export const spinFree = async (id) => {
  try {
    return await api.get(`${endpoints.spinFree}/${id}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const addCart = async (payload) => {
  try {
    return await api.post(`${endpoints.addCart}`, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const getCart = async ({ id, page = 1 }) => {
  try {
    return await api.get(`${endpoints.getCart}/${id}`, {
      params: { page },
    });
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get All Battles
export const getAllBattles = async (payload) => {
  try {
    return await api.get(`${endpoints.getAllBattles}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const getAllBattlesByUser = async (payload) => {
  try {
    return await api.get(`${endpoints.getAllBattlesByUser}?results=${payload}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get  Battles by ID

export const getBattlesById = async (payload) => {
  try {
    return await api.post(endpoints.getBattlesById, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const battleCancel = async (id) => {
  try {
    return await api.post(`${endpoints.battleCancel}/${id}/cancel`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};
//post battles

export const postBattles = async (payload) => {
  try {
    return await api.post(endpoints.postBattles, payload);
  } catch (error) {
    throw {
      ...error,
      message:
        error?.response?.data?.message || error?.message || "Request failed",
    };
  }
};

export const joinBattle = async (battleId) => {
  try {
    return await api.post(endpoints.joinBattle(battleId));
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const battlePlayTrigger = async (payload) => {
  try {
    return await api.post(`${endpoints.battlePlayTrigger}`, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const FlipStatus = async (payload) => {
  try {
    return await api.post(`${endpoints.FlipStatus}`, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// post Contacts
export const ContactUs = async (payload) => {
  try {
    return await api.post(`${endpoints.ContactUs}`, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// post referrers
export const referrerProgram = async (payload) => {
  return api.post(`${endpoints.BecomeReferrer}`, payload);
};

// sell items
export const sellItem = (payload) => {
  return api.post(endpoints.sellItem, payload);
};

// ship items
export const shipItems = (payload) => {
  return api.post(endpoints.shipItems, payload);
};

//get  list of coins
export const getCoins = async () => {
  try {
    return await api.get(`${endpoints.getCoins}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const getWalletAddress = async (payload) => {
  try {
    return await api.post(`${endpoints.getWalletAddress}`, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get  list of social links
export const footerLinks = async () => {
  try {
    return await api.get(`${endpoints.footerSocialLinks}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get  list of balance
export const getAccountBalance = async () => {
  try {
    return await api.get(`${endpoints.getBalance}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//withdraw
export const WithDraw = async (payload) => {
  return api.post(endpoints.WithDraw, payload);
};

export const Deposit = async (payload) => {
  try {
    return await api.post(`${endpoints.Deposit}`, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//Exchange Rate
export const ExchangeRate = async (payload) => {
  try {
    return await api.post(`${endpoints.ExchangeRate}`, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const FaqHtml = async () => {
  try {
    return await api.get(endpoints.faq);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const TermsHtml = async () => {
  try {
    return await api.get(endpoints.terms);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const privacyHtml = async () => {
  try {
    return await api.get(endpoints.privacy);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const provablyHtml = async () => {
  try {
    return await api.get(endpoints.provably);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const cookieHtml = async () => {
  try {
    return await api.get(endpoints.cookie);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const policyHtml = async () => {
  try {
    return await api.get(endpoints.policy);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get transactions
export const GetTransaction = async (
  page = 1,
  search = "",
  sortBy = "",
  sortOrder = "",
  gameHistory = null,
) => {
  try {
    let url = `${endpoints.GetTransaction}?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (sortBy) {
      url += `&sort_by=${encodeURIComponent(sortBy)}`;
    }
    if (sortOrder) {
      url += `&sort_order=${encodeURIComponent(sortOrder)}`;
    }
    if (gameHistory) {
      url += `&game_history=${encodeURIComponent(gameHistory)}`;
    }

    return await api.get(url);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//documents upload
export const Document = async (payload) => {
  return api.post(endpoints.Document, payload);
};
//get clint seed
export const Fairness = async () => {
  try {
    return await api.get(`${endpoints.Fairness}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};
//post api to change clint seed
export const PostSeed = async (payload) => {
  return api.post(endpoints.PostSeed, payload);
};

// get Top up with pagination + search + sorting
export const Topup = async (
  page = 1,
  search = "",
  sortBy = "",
  sortOrder = "",
) => {
  try {
    let url = `${endpoints.Topup}?page=${page}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (sortBy) url += `&sort_by=${encodeURIComponent(sortBy)}`;
    if (sortOrder) url += `&sort_order=${encodeURIComponent(sortOrder)}`;
    return await api.get(url);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// get Withdrawals with pagination + search
export const Withdrawal = async (
  page = 1,
  search = "",
  sortOrder = "desc",
  sortBy = "created_at",
) => {
  try {
    let url = `${endpoints.Withdrawals}?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (sortBy) {
      url += `&sort_by=${encodeURIComponent(sortOrder)}`;
    }
    if (sortOrder) {
      url += `&sort_order=${encodeURIComponent(sortBy)}`;
    }
    return await api.get(url);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// get all avatars
export const getAvatar = async () => {
  return await api.get(endpoints.avatars);
};

//avatar change
export const updateAvatar = async (payload) => {
  return await api.post(endpoints.userAvatar, payload);
};
//Flipcoin
export const FlipCoin = async (payload) => {
  try {
    return await api.post(endpoints.FlipCoin, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get Footer Logo
export const getFooterLogo = async () => {
  try {
    return await api.get(`${endpoints.footerLogo}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//reset Password
export const ResetOldPassword = async (payload) => {
  try {
    return await api.post(endpoints.resetPassword, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//Forget Password
export const ForgotPassword = async (payload) => {
  try {
    return await api.post(endpoints.forgotPassword, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//send user Verification email
export const userVerificationEmail = async (payload) => {
  try {
    return await api.post(endpoints.sendVerificationEmail, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// Logout
export const Logout = async () => {
  try {
    return await api.post(endpoints.logout);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get slider content
export const getSlider = async () => {
  try {
    return await api.get(`${endpoints.Slider}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//get Slider Content
export const GetDocument = async () => {
  try {
    return await api.get(`${endpoints.GetDocument}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// get all notificaitons data
export const getNotificaitons = async (page = 1) => {
  try {
    const response = await api.get(`${endpoints.notificaiton}?page=${page}`);
    return response;
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// mark single notificaitons as read
export const markNotificaitonRead = async (payload, read = "mark-read") => {
  try {
    return await api.post(`${endpoints.notificaiton}/${read}`, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// mark all notificaitons as read
export const markAllNotificaitonsRead = async (
  payload,
  readAll = "mark-all-read",
) => {
  try {
    return await api.post(`${endpoints.notificaiton}/${readAll}`, payload);
  } catch (error) {
    return { success: false, message: error.message };
  }
};
export const fetchBattleDetails = async (battleId) => {
  try {
    const response = await api.get(`${endpoints.postBattles}/${battleId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching battle ${battleId}:`, error);
    return { success: false, message: error.message };
  }
};
export const acknowledgeBattleStart = async (battleId) => {
  try {
    const response = await api.post(
      `${endpoints.postBattles}/${battleId}/acknowledge-start`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error acknowledging battle ${battleId}:`, error);
    return { success: false, message: error.message };
  }
};
export const fetchBattleResult = async (battleId) => {
  try {
    const response = await api.get(
      `${endpoints.postBattles}/${battleId}/history`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching battle result for ${battleId}:`, error);
    return { success: false, message: error.message };
  }
};

// get languages
export const getLanguages = async () => {
  try {
    return await api.get(`${endpoints.languages}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// check IP
export const checkIp = async () => {
  try {
    return await api.get(`${endpoints.ipCheck}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// Pending Withdrawals
export const fetchPendingWithdrawals = async () => {
  try {
    return await api.get(`${endpoints.pendingWithdrawals}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const sendUtmData = async ({ code_used, sub_id }) => {
  try {
    const response = await api.post(endpoints.utm, {
      code_used,
      sub_id,
    });

    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};
export const enterBattle = async (battleId) => {
  try {
    const response = await api.post(
      `${endpoints.postBattles}/${battleId}/enter`,
    );
    return response.data;
  } catch (error) {
    console.error("Enter battle error:", error);
    throw error;
  }
};

// get promotion popups
export const getPromotionPopups = async () => {
  return await api.get(`${endpoints.promotionPopups}`);
};

// Cancel Withdrawal Payout
export const cancelWithdrawalPayout = async (breeze_id) => {
  return api.post(`${endpoints.cancelWithdrawal}/${breeze_id}`);
};
export const allBattleBoxes = async () => {
  try {
    return await api.get(`${endpoints.battleBoxes}`);
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// Delete Account
export const deleteOwnAccount = async () => {
  return api.post(`${endpoints.deleteUser}`);
};
export const getRaffle = async () => {
  try {
    return api.get("/get-draw-date");
  } catch (error) {
    return { success: false, message: error.message };
  }
};
